import { render, staticRenderFns } from "./ZoopSplitModal.vue?vue&type=template&id=55d61e08&"
import script from "./ZoopSplitModal.vue?vue&type=script&lang=js&"
export * from "./ZoopSplitModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports